import { render } from "./HeroiconsSolidInbox.vue?vue&type=template&id=0861ce4e"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidInbox.vue"]])

export default __exports__